import React from 'react';
import { Box } from '@mui/material';

interface DashboardCardContentProps {
  children: React.ReactNode;
}

const DashboardCardContent: React.FC<DashboardCardContentProps> = ({
  children,
}) => {
  return (
    <Box sx={{ p: 2, pt: 0, minWidth: 0 }}>
      {children}
    </Box>
  );
};

export default DashboardCardContent;
